import { SecondaryButton } from '@workspace/ui/components/dsm/secondary-button'
import { EmptyState } from '@workspace/ui/components/empty-state'
import { LoadingSpinner } from '@workspace/ui/components/loading-spinner'
import type { ReactNode } from 'react'
import { useMcpSettingsQuery } from '../features/investor-assistant/hooks/use-investor-assistant'
import { InvestorLayout } from './investor-layout'

/** The investor pages exist twice: the new ones for accounts the AI assistant is open for, the classic ones for the rest. */
export function AssistantSwitch({
  assistant,
  classic,
}: {
  assistant: ReactNode
  classic: ReactNode
}) {
  const { data, isLoading, error, refetch } = useMcpSettingsQuery()
  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }
  if (error || !data?.data) {
    return <AssistantLoadError onRetry={() => refetch()} />
  }
  return data.data.assistantEnabled === true ? assistant : classic
}

/** The settings that pick between the two sets of pages could not be read: say so, with a retry. */
export function AssistantLoadError({ onRetry }: { onRetry: () => void }) {
  return (
    <InvestorLayout activeNav="">
      <EmptyState
        title="Could not load this page"
        description="Try again in a moment."
        action={<SecondaryButton onClick={onRetry}>Try again</SecondaryButton>}
      />
    </InvestorLayout>
  )
}
